import { EVENTS } from './tracking';
import { getTrackingStats } from '../services/tracking';
import {
    useAuth,
} from '../stores/auth-store';
import { useProfile } from '../stores/profile-store';

export function makeConsoleTracker() {
    return {
        enable() {
        },
        event({
            event = 'click_element',
            element = null,
            elementDetail = null,
            funnelType = null,
            funnelStep = null,
            funnelVariant = null,
            jobId = null,
            applicationType = null,
            userData = null,
            jobType = null,
            productType = null,
            ...unexpectedExtraParams
        } = {}) {
            if (Object.keys(unexpectedExtraParams).length > 0) {
                // eslint-disable-next-line no-console
                console.warn(
                    'Console tracking called with unexpected parameters, these are not pushed into the ' +
                    'dataLayer and subsequently are not properly tracked! Unhandled parameters:',
                    Object.keys(unexpectedExtraParams).join(', '),
                );
            }

            // eslint-disable-next-line no-console
            console.log(event, {
                event,
                element,
                element_detail: elementDetail,
                funnel_type: funnelType,
                funnel_step: funnelStep,
                funnel_variant: funnelVariant,
                job_id: jobId,
                job_type: jobType,
                product_type: productType,
                application_type: applicationType,
                user_data: userData,
            });
        },
        trackABTest({ name, variant }) {
            // eslint-disable-next-line no-console
            console.log(EVENTS.abTest, {
                event: EVENTS.abTest,
                ab_test_name: name,
                ab_test_variant: variant,
            });
        },
        trackVisibility({ element = null, elementDetail = null }) {
            // eslint-disable-next-line no-console
            console.log(EVENTS.trackVisibility, {
                event: EVENTS.trackVisibility,
                element,
                // eslint-disable-next-line camelcase
                element_detail: elementDetail,
            });
        },
        async trackUser() {
            try {
                const auth = useAuth();
                const profile = useProfile();
                const userUuid = auth.uuid;
                const userType = userUuid ? 'user' : 'guest';
                const tracking = userUuid ? await getTrackingStats() : null;

                // eslint-disable-next-line no-console
                console.log(EVENTS.userdata, {
                    ...tracking,
                    event: EVENTS.userdata,
                    userType,
                    userTypeDetail: profile.userTypeDetail,
                    userId: userUuid,
                });
            } catch (exception) { /* empty */ }
        },
        trackVirtualPageView({ pageUrl, pageTitle }) {
            // eslint-disable-next-line no-console
            console.log(EVENTS.pageView, {
                event: EVENTS.pageView,
                pageUrl,
                pageTitle,
            });
        },
    };
}
